import { createIcon } from '../createIcon';
import { ReactComponent as IconErase } from '../svg/erase.svg';

export default createIcon(IconErase);
